import type { Page } from "../constants/pages";

import { PAGES } from "../constants/pages";

export const pageToRender = (view: Page | null) => {
  if (view === null) {
    return PAGES.RESULTS;
  }

  const pages_array: Page[] = [
    PAGES.ASYNC_CART,
    PAGES.TICKET_OPTIONS,
    PAGES.SEAT_SELECTION
  ];

  if (pages_array.includes(view)) {
    return view;
  }

  return PAGES.RESULTS;
};
